export const PASSWORD_RESET_STATUS_FORM = 'form'
export const PASSWORD_RESET_STATUS_SUCCESS = 'success'
export const PASSWORD_RESET_STATUS_ERROR = 'error'
export const PASSWORD_RESET_STATUS_EXPIRED = 'expired'

export const RECAPTCHA_ACTION_PASSWORD_RECOVERY = 'passwordRecoveryRequest'
export const RECAPTCHA_ACTION_PASSWORD_RESET = 'passwordReset'
